const API_BASE = process.env.REACT_APP_API_URL || "/api";
const SESSION_KEY = "liarthur_session";

const request = async (path, options = {}) => {
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.detail || "İşlem tamamlanamadı.");
  return data;
};

export const getSession = () => {
  const session = JSON.parse(localStorage.getItem(SESSION_KEY) || "null");
  if (!session?.token || !session?.username) return null;
  return session;
};

export const getAuthToken = () => getSession()?.token || null;

const storeSession = (session) => {
  localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  window.dispatchEvent(new Event("liarthur-auth-change"));
  return session;
};

export const login = async ({ username, password }) => {
  return storeSession(
    await request("/auth/login", {
      method: "POST",
      body: JSON.stringify({ username, password }),
    })
  );
};

export const register = async ({ name, username, password }) => {
  return storeSession(
    await request("/auth/register", {
      method: "POST",
      body: JSON.stringify({ name, username, password }),
    })
  );
};

export const resetPassword = async ({ username, password }) => {
  return storeSession(
    await request("/auth/reset-password", {
      method: "POST",
      body: JSON.stringify({ username, password }),
    })
  );
};

export const logout = async () => {
  const session = getSession();
  localStorage.removeItem(SESSION_KEY);
  window.dispatchEvent(new Event("liarthur-auth-change"));

  if (session?.token) {
    try {
      await request("/auth/logout", {
        method: "POST",
        headers: { Authorization: `Bearer ${session.token}` },
      });
    } catch {
      // Local logout is enough if the API is not reachable.
    }
  }
};
